import { createAsyncThunk } from '@reduxjs/toolkit'
import { authPost, authGet, upload } from '../../../api'
import { urlConsole } from '../../../config'
import { IVoiceEmotion } from '../../../@types/tts'

export interface ICreateVoiceGroupPayload {
  name: string
  is_default: boolean
  voices: string[]
  users?: { user_id: number; username: string }[]
}

export interface IUpdateVoiceGroupPayload {
  voice_group_id: number
  name?: string
  is_default?: boolean
  voices?: string[]
  users?: { user_id: number; username: string }[]
}

export const getVoiceGroups = createAsyncThunk(
  'voiceGroups/getVoiceGroups',
  async () => {
    const res = await authGet(urlConsole + '/get_voice_groups')
    return res.data?.voice_groups ?? []
  }
)

export const createVoiceGroup = createAsyncThunk(
  'voiceGroups/createVoiceGroup',
  async (data: ICreateVoiceGroupPayload) => {
    const res = await authPost(urlConsole + '/create_voice_group', data as unknown as Record<string, unknown>)
    return res.data
  }
)

export const deleteVoiceGroup = createAsyncThunk(
  'voiceGroups/deleteVoiceGroup',
  async (voice_group_id: number) => {
    const res = await authPost(urlConsole + '/delete_voice_group', { voice_group_id } as unknown as Record<string, unknown>)
    return res.data
  }
)

export const getUserVoiceAccess = createAsyncThunk(
  'voiceGroups/getUserVoiceAccess',
  async (user_id: number) => {
    const res = await authGet(urlConsole + `/get_user_voice_access?user_id=${user_id}`)
    return res.data
  }
)

export const updateUserVoiceAccess = createAsyncThunk(
  'voiceGroups/updateUserVoiceAccess',
  async (data: { user_id: number; voice_group_ids: number[] }) => {
    const res = await authPost(urlConsole + '/update_user_voice_access', data as unknown as Record<string, unknown>)
    return res.data
  }
)

export const updateVoiceGroup = createAsyncThunk(
  'voiceGroups/updateVoiceGroup',
  async (data: IUpdateVoiceGroupPayload) => {
    const res = await authPost(urlConsole + '/update_voice_group', data as unknown as Record<string, unknown>)
    return res.data
  }
)

export interface IUpdateVoicePayload {
  technical_name: string
  display_name?: string
  language_code?: string
  language_name?: string
  gender?: 'male' | 'female'
  disclaimer?: string
  is_visible?: boolean
  emotions?: IVoiceEmotion[]
}

export const updateVoice = createAsyncThunk(
  'voiceGroups/updateVoice',
  async (data: IUpdateVoicePayload) => {
    const res = await authPost(urlConsole + '/update_voice', data as unknown as Record<string, unknown>)
    return res.data
  }
)

export const uploadVoiceAvatar = createAsyncThunk(
  'voiceGroups/uploadVoiceAvatar',
  async ({ technical_name, file }: { technical_name: string; file: File | null }) => {
    const form = new FormData()
    form.append('technical_name', technical_name)
    if (file) form.append('file', file)
    const res = await upload(urlConsole + '/upload_voice_avatar', form)
    return res.data
  }
)

export const deleteVoiceAvatar = createAsyncThunk(
  'voiceGroups/deleteVoiceAvatar',
  async (technical_name: string) => {
    const res = await authPost(urlConsole + '/delete_voice_avatar', { technical_name } as unknown as Record<string, unknown>)
    return res.data
  }
)

export const uploadVoiceSample = createAsyncThunk(
  'voiceGroups/uploadVoiceSample',
  async ({ technical_name, file }: { technical_name: string; file: File }) => {
    const form = new FormData()
    form.append('technical_name', technical_name)
    form.append('file', file)
    const res = await upload(urlConsole + '/upload_voice_sample', form)
    return res.data
  }
)
